// extracted by mini-css-extract-plugin
module.exports = {"negativeAnalysisDetail":"negativeDetail_negativeAnalysisDetail__3vq3t","negativeDetailNumber":"negativeDetail_negativeDetailNumber__2I8Vd"};